const shortid = require('shortid');

const uniq = arr => arr.filter((v, i, a) => a.indexOf(v) === i);
const getUrl = file => (
  `${`https://thirdspace-dev-serverless.s3.amazonaws.com/thumbs/${file.Key}`}`
)

const sortByDate = (a, b) => {
  const [day_a, month_a, year_a] = a.date.split(" ");
  const [day_b, month_b, year_b] = b.date.split(" ");

  const date_a = new Date(
    parseInt(`20${year_a}`, 10),
    parseInt(month_a, 10) - 1,
    parseInt(day_a, 10)
  );

  const date_b = new Date(
    parseInt(`20${year_b}`, 10),
    parseInt(month_b, 10) - 1,
    parseInt(day_b, 10)
  );

  return date_b - date_a
};

const transform = files => {
  return files.map(file => {
    const name = file.Key.split("/")[1];
    const date = name.substring(0, 8);
    const formattedDate = `${date.substring(0, 2)} ${date.substring(2, 4)} ${date.substring(4)}`
    const location = name.substring(8).split("-")[0];
    const url = getUrl(file);
    const title = `${formattedDate} ${location}`

    return {
      id: shortid.generate(),
      Key: file.Key,
      title,
      date: formattedDate,
      location,
      url
    };
  }).sort(sortByDate)
}

const getFilters = files => ({
  dates: uniq(files.map(file => file.date)),
  locations: uniq(files.map(file => file.location)),
})

export { getFilters, transform };